<template>
  <Paper class="color-block" :style="styles">
    <RatioBox :ratio="1">
      <span class="color-block__text">{{ color }}</span>
    </RatioBox>
  </Paper>
</template>

<script>
import { Paper, RatioBox } from '@campsite-bio/component-lib';
import { computed } from '@vue/composition-api';
import tinycolor from 'tinycolor2';

export default {
  components: {
    Paper,
    RatioBox,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const color = computed(() => {
      return tinycolor(props.value).toHexString();
    });

    const styles = computed(() => {
      return {
        backgroundColor: props.value,
        color: tinycolor(props.value).isDark() ? '#fff' : '#000',
      };
    });

    return {
      color,
      styles,
    };
  },
};
</script>

<style lang="scss" scoped>
.color-block {
  font-size: 1.5rem;

  &__text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
